import { defineComponent as n, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as s } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconDoubleChevronSideways",
  __name: "IconDoubleChevronSideways",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (a(), r(l(i), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        s("path", { d: "M10.53 8.53 7.06 12l3.47 3.47a.75.75 0 1 1-1.06 1.06l-3.647-3.646a1.25 1.25 0 0 1 0-1.768L9.47 7.47a.75.75 0 1 1 1.06 1.06m2.94 6.94L16.94 12l-3.47-3.47a.75.75 0 0 1 1.06-1.06l3.647 3.646a1.25 1.25 0 0 1 0 1.768L14.53 16.53a.75.75 0 1 1-1.06-1.06" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
